module.exports = __webpack_public_path__ + "entry-150bfe9b/kaufland-photo-685f82764ae3649d88d244ea86a607aa.webp";